import React, { useMemo } from "react";
import classes from "./useradmin.module.scss";

import { Button, Spinner } from "./../../Utils";
import InstitutionCard from "./Comps/InstitutionCard";

// # COMPONENT
const InstitutionList = ({
  list,
  isShowMoreBtn,
  isEnd,
  loading,
  moreBtnHandler,
  isEmpty,
  onEditClickHandler,
}) => {
  // THIS IS RENDER
  const _renderList = useMemo(() => {
    return list.map((_o, i) => (
      <InstitutionCard
        key={i}
        {..._o}
        style={{ overflow: "unset" }}
        onEditClick={() => onEditClickHandler(_o)}
      />
    ));
  }, [list]);

  return (
    <div className={classes["feeds-container"]}>
      <div className={classes["space-y"] + " " + classes["feeds-wrapper"]}>
        {_renderList}
        {loading && <Spinner />}

        {isShowMoreBtn && !isEnd && !loading && (
          <div className={classes["more-btn"]}>
            <Button onClick={moreBtnHandler}>MORE</Button>
          </div>
        )}
        {/* {isEnd && !loading && (
          <p style={{ textAlign: "center" }}>No More Users</p>
        )} */}
        {isEmpty && !loading && <p style={{ textAlign: "center" }}>Empty</p>}
      </div>
    </div>
  );
};

export default InstitutionList;
